import { coreMessages, type AppLocale } from './base-messages';

export const tr: AppLocale = {
    ...coreMessages,
    dataTable: {
      rowModeLabel: 'Satır görünümü',
      rowModeEllipsis: 'Kısalt (…)',
      rowModeScroll: 'Tek satır + yatay kaydır',
      rowModeWrap: 'Satır kır',
      columnsLabel: 'Sütunlar',
      reorderColumnHint: 'Sütunu taşımak için tutamacı sürükleyin',
      resetThisTablePrefs: 'Bu tabloyu sıfırla',
      resetThisTablePrefsTitle: 'Yalnızca bu tablo için kayıtlı görünümü sil (satır modu, sütunlar, sıra, genişlik). Genel kullanıcı ayarlarına dokunmaz.',
      dataOperationsLabel: 'Veri İşlemleri',
      operationExportExcel: 'Excel indir',
      operationDownloadTemplate: 'Şablon indir',
      operationUploadTemplate: 'Şablon yükle',
      operationImportHistory: 'Yükleme geçmişi',
      operationFieldDictionary: 'Alan sözlüğü',
      operationUnsupported: 'Bu tablo bu işlemi desteklemiyor.',
      operationNoPermission: 'Bu işlem için yetkiniz yok.',
      operationNotReady: 'Bu işlem henüz hazır değil.',
      customFieldColumnsSectionLabel: 'Ek Alanlar',
      importModalTitle: 'Şablon yükle',
      importChooseFile: 'CSV dosyası seç',
      importChooseFileHint: 'Bu tablodan indirilen şablonu doldurup yükleyin.',
      importNoFile: 'Dosya seçilmedi.',
      importSummary: 'Yükleme özeti',
      importReadyRows: 'Hazır satır',
      importErrorRows: 'Hatalı satır',
      importWarnings: 'Uyarılar',
      importUnknownHeaders: 'Bilinmeyen kolonlar',
      importMissingRequiredHeaders: 'Eksik zorunlu kolonlar',
      importPreview: 'Ön izleme',
      importSubmit: 'Yüklemeyi başlat',
      importCancel: 'Vazgeç',
      importParsing: 'Dosya okunuyor...',
      importSubmitting: 'Yükleniyor...',
      importNoValidRows: 'Yüklenecek geçerli satır yok.',
      importFailed: 'Yükleme başarısız.',
      importSucceeded: 'Yükleme tamamlandı.',
      operationExportCsv: 'CSV indir',
      operationExportPdf: 'PDF indir',
      operationNoRows: 'Dışa aktarılacak görünür satır yok.',
      importUnknownHeader: 'Bilinmeyen kolon: {header}',
      importMissingRequiredHeader: 'Zorunlu kolon eksik: {header}',
      importRequiredCell: '{header} zorunlu.',
      importMaxRowsExceeded: 'Dosyada {maxRows} satırdan fazlası var; ilk {maxRows} satır değerlendirildi.',
      refreshLabel: 'Yenile',
      focusModeEnterLabel: 'Tabloya odaklan',
      focusModeFullscreenLabel: 'Tam ekrana geç',
      focusModeExitLabel: 'Tablo odağından çık',
      horizontalScrollLabel: 'Tablo sütunlarını kaydır',
      selectionModeLabel: 'Satır seçimi',
      selectAllRowsLabel: 'Tüm satırları seç',
      selectRowLabel: 'Satırı seç',
      bulkSelectedLabel: '{count} seçili',
      bulkActionsLabel: 'Toplu işlemler',
      tableSettingsLabel: 'Tablo ayarları',
      appearanceSectionLabel: 'Görünüm',
      columnsSectionLabel: 'Sütunlar',
      rowActionsLabel: 'Satır işlemleri',
    },
    passwordReset: {
      title: 'Yeni Şifre Belirle',
      description: 'Hesabınız için güçlü ve yalnız size ait yeni bir şifre belirleyin.',
      newPassword: 'Yeni şifre',
      confirmPassword: 'Yeni şifre tekrar',
      passwordHelp: 'En az 12 karakter ve küçük harf, büyük harf, rakam, özel karakter türlerinden en az üçünü kullanın.',
      mismatch: 'Şifreler eşleşmiyor.',
      invalidLink: 'Şifre sıfırlama bağlantısı eksik, geçersiz veya süresi dolmuş.',
      submit: 'Şifreyi güncelle',
      submitting: 'Şifre güncelleniyor...',
      success: 'Şifreniz güncellendi. Yeni şifrenizle giriş yapabilirsiniz.',
      backToLogin: 'Giriş ekranına dön',
      requestTitle: 'Şifre sıfırlama bağlantısı gönder',
      requestDescription: 'Kullanıcının kayıtlı e-posta adresine 30 dakika geçerli, tek kullanımlık bir bağlantı gönderilir. Bağlantı kullanılana kadar mevcut şifre değişmez.',
      requestSend: 'Bağlantıyı gönder',
      requestSending: 'Gönderiliyor...',
      requestSuccess: 'Şifre sıfırlama bağlantısı gönderim için kabul edildi.',
      requestError: 'Şifre sıfırlama bağlantısı gönderilemedi.',
      selfServiceOpen: 'Şifremi unuttum',
      selfServiceTitle: 'Şifremi Unuttum',
      selfServiceDescription: 'Kurumsal hesabınızın e-posta adresini girin. Kayıt eşleşirse 30 dakika geçerli, tek kullanımlık bir bağlantı gönderilir.',
      selfServiceEmailLabel: 'E-posta',
      selfServiceSubmit: 'Bağlantı iste',
      selfServiceSubmitting: 'İstek gönderiliyor...',
      selfServiceAcknowledgement: 'Bu e-posta adresi kayıtlıysa şifre sıfırlama bağlantısı gönderilecektir. Lütfen gelen kutunuzu ve istenmeyen postaları kontrol edin.',
      selfServiceClose: 'Kapat',
      selfServiceCancel: 'İptal',
      selfServiceError: 'Şifre sıfırlama isteği şu anda tamamlanamadı. Lütfen daha sonra tekrar deneyin.',
      selfServiceRateLimited: 'Çok fazla istek gönderdiniz. Lütfen daha sonra tekrar deneyin.',
    },
    relationshipGraph: {
      sourceColumn: 'Kaynak',
      relationshipColumn: 'İlişki',
      targetColumn: 'Bağlı kayıt',
      showDetails: 'Ayrıntıları göster',
      hideDetails: 'Ayrıntıları gizle',
      controlsLabel: 'Harita kontrolleri',
      title: 'İlişki Haritası',
      diagramLabel: 'Kayıt ilişkileri',
      diagramHelp: 'Kaydedilmiş bağlantıları incelemek için bir kart seçin.',
      detailsTitle: 'Kayıt ayrıntıları',
      connectionsTitle: 'Bağlantılar',
      noConnections: 'Bağlantı yok',
      loading: 'İlişkiler yükleniyor…',
      forbidden: 'İlişkileri görüntüleme erişiminiz yok.',
      error: 'İlişkiler yüklenemedi. Kapatıp yeniden deneyin.',
      empty: 'Bu kaydın gösterilebilen bağlantısı yok.',
      invalid: 'İlişki verisi doğrulanamadı. Kapatıp yeniden deneyin.',
      close: 'İlişki haritasını kapat',
      zoomIn: 'Yakınlaştır',
      zoomOut: 'Uzaklaştır',
      fitView: 'Haritayı sığdır',
    },
    permissionPicker: {
      application: 'Ürün',
      module: 'Modül',
      action: 'İşlem',
      permissions: 'İzinler',
      description: 'Açıklama',
      selection: 'Seçim',
      sharedPermissions: 'Ortak izinler',
      selectedPermissions: '{count} izin seçildi',
      selectedOnly: 'Yalnız seçililer',
      unselectedOnly: 'Yalnız seçili olmayanlar',
      selectedFirst: 'Seçililer önce',
      noPermissions: 'İzin yok',
    },
    errors: {
        ...coreMessages.errors,
        unknown: 'Bilinmeyen bir hata oluştu',
        network: 'Sunucuya ulaşılamıyor. Bağlantınızı kontrol edin.',
        timeout: 'İstek zaman aşımına uğradı. Lütfen tekrar deneyin.',
        badRequest: 'Geçersiz istek.',
        unauthorized: 'Oturum açmanız gerekiyor.',
        forbidden: 'Bu işlem için yetkiniz yok.',
        notFound: 'İstenen kaynak bulunamadı.',
        tooManyRequests: 'Çok fazla istek. Lütfen bekleyip tekrar deneyin.',
        internalServerError: 'Sunucu hatası. Daha sonra tekrar deneyin.',
        badGateway: 'Ağ geçidi hatası. Daha sonra tekrar deneyin.',
        serviceUnavailable: 'Hizmet geçici olarak kullanılamıyor.',
        gatewayTimeout: 'Ağ geçidi zaman aşımı. Tekrar deneyin.',
        serverErrorWithStatus: 'Sunucu hatası ({status})',
    },
    common: {
    databaseUnavailableDeveloperHint: 'Geliştirici notu: Yerel ortamda bu durum genellikle VPN kapalıyken veya IP erişimi tanımlı değilken oluşur. VPN ve veritabanı erişim izninizi kontrol edin.',
        ...coreMessages.common,
        requestTimeout: 'İstek zaman aşımına uğradı. Lütfen tekrar deneyin.',
        backendConnectionErrorDev:
            'API ile bağlantı kurulamadı. VITE_API_BASE_URL / proxy ve API sunucusunu kontrol edin.',
        backendConnectionErrorProd: 'Sunucuya bağlanılamıyor. Daha sonra tekrar deneyin.',
        systemUpdating: 'Sistem güncelleniyor. Kısa süre sonra tekrar deneyin.',
        serverConfiguring: 'Sunucu yapılandırılıyor. Lütfen bekleyin…',
        forbidden: 'Erişim reddedildi.',
        network: 'Ağ hatası.',
        select: 'Seçin…',
        cancel: 'İptal',
        save: 'Kaydet',
        saving: 'Kaydediliyor...',
        edit: 'Düzenle',
        view: 'İncele',
        copy: 'Kopyala',
        delete: 'Sil',
        appLauncher: 'Uygulamalar',
        allApps: 'Tüm Uygulamalar',
        loading: 'Yükleniyor...',
        noData: 'Veri yok',
        code: 'Kod',
        profileMenu: 'Profil menüsü',
        selectLanguage: 'Dil seçin',
        perPage: 'Sayfa başına',
        firstPage: 'İlk sayfa',
        previousPage: 'Önceki sayfa',
        nextPage: 'Sonraki sayfa',
        lastPage: 'Son sayfa',
        pleaseWait: 'Lütfen bekleyin',
        migrationDescription: 'Veritabanı güncellemesi sürüyor olabilir.',
        changeText: 'Değiştir',
        deleteLogo: 'Logoyu kaldır',
        logoUploadHint: 'PNG veya JPG, birkaç MB’ı geçmesin.',
        deleteAvatar: 'Fotoğrafı kaldır',
        avatarUploadHint: 'PNG veya JPG.',
        newRecord: 'Yeni kayıt',
        noPermission: 'Yetkiniz yok',
        searchPlaceholder: 'Ara…',
        allStatuses: 'Tüm durumlar',
        active: 'Aktif',
        inactive: 'Pasif',
        clearFilters: 'Filtreleri temizle',
        all: 'Tümü',
        clickToChangeStatus: 'Durumu değiştirmek için tıklayın',
        noChangePermission: 'Durum değiştirme yetkisi yok',
        statusDistribution: 'Durum dağılımı',
        hide: 'Gizle',
        show: 'Göster',
        companies: 'Firmalar',
        adminConsole: 'Yönetici Konsolu',
        manageAccount: 'Hesabı yönet',
        manageYourAccount: 'Hesabınızı yönetin',
      notificationsTitle: 'Bildirimler',
      notificationsUnread: 'okunmayan',
      notificationsTypesMuted: 'tip sessizde',
      notificationsViewAll: 'Tümünü Aç',
      notificationsPreferences: 'Tercihler',
      notificationsMutedLabel: 'Sessizde',
      notificationsEmpty: 'Bildirim yok',
      selectAll: 'Tümünü seç',
      id: 'No.',
      remove: 'Kaldır',
      syncDeletedResult: '{count} geçersiz çeviri kaydı silindi.',
      distributionByTable: 'Tablo (bağlam) dağılımı',
      distributionByLocale: 'Dil (locale) dağılımı',
      translationReport: 'Çeviri Durum Dağılımı',
      page: 'Sayfa',
      rows: 'satır',
      actions: 'İşlemler',
      create: 'Oluştur',
      search: 'Ara',
      closeSearch: 'Aramayı kapat',
      help: 'Yardım',
      helpCenter: 'Yardım Merkezi',
      helpAboutPage: 'Bu sayfa hakkında',
      helpDocumentation: 'Dokümantasyon',
      helpKeyboardShortcuts: 'Klavye kısayolları',
      helpWhatsNew: 'Yenilikler',
      helpF1Hint: 'Bu sayfa hakkında yardım için F1’e basın',
      helpNoDocsForPage: 'Bu sayfa için henüz dokümantasyon yok',
      aiAssistantTitle: 'QubePro AI Asistan',
      aiAssistantButton: 'AI Asistan',
      aiAssistantUnavailable: 'AI asistan şu anda kullanılamıyor.',
      appearancePreference: 'Görünüm Tercihi',
      modalControlPlacement: 'Form Kontrol Yerleşimi',
      modalControlPlacementHint: 'Formların kapat ve tam ekran kontrollerinin konumunu belirler.',
      modalControlPlacementSystem: 'Sistem (Önerilen)',
      modalControlPlacementWindows: 'Windows',
      modalControlPlacementMacos: 'macOS',
      productTour: {
        start: 'Ürün turunu başlat',
        restart: 'Ürün turunu yeniden başlat',
        navigationTitle: 'Sol menü ve modüller',
        navigationDescription: 'Yetkiniz olan modül ve sayfalara sol menüden erişin; bölüm başlıklarını açıp kapatabilirsiniz.',
        appsTitle: 'Uygulamalar',
        appsDescription: 'QubePro uygulamalarınızı buradan açın ve uygulamalar arasında geçiş yapın.',
        profileTitle: 'Profil ve firma',
        profileDescription: 'Profilinizi, firma seçiminizi ve dil tercihlerinizi buradan yönetin.',
        aiTitle: 'QubePro AI',
        aiDescription: 'Bulunduğunuz sayfaya göre yardım almak için QubePro AI asistanını açın.',
        helpTitle: 'Yardım Merkezi',
        helpDescription: 'Dokümantasyona ulaşın veya bu ürün turunu istediğiniz zaman yeniden başlatın.',
        next: 'İleri',
        previous: 'Geri',
        done: 'Tamam',
        close: 'Kapat',
        neverShowAgain: 'Bir daha otomatik gösterme',
        progress: '{{current}} / {{total}}',
      },
      userExtensions: 'Eklentiler',
      close: 'Kapat',
      modalFocus: 'Forma odaklan',
      modalFullscreen: 'Tam ekrana geç',
      modalRestore: 'Eski boyuta dön',
      filterByColumn: '{column} filtresi',
      formCustomFieldsLoading: 'Ek alanlar yükleniyor…',
      formCustomFieldsLoadError: 'Ek alanlar yüklenemedi. Veri kaybını önlemek için kaydetmeden önce tekrar deneyin.',
      formCustomFieldsRetry: 'Tekrar dene',
      pageUnavailableTitle: 'Sayfa açılamadı',
      pageUnavailableMessage: 'Menüden başka bir sayfaya geçebilir veya bu sayfayı yenileyebilirsiniz.',
      pageReloadWarning: 'Yenileme, kaydedilmemiş değişiklikleri siler.',
      allTargetLanguages: 'Tüm diller (10 dil)',
      darkMode: 'Karanlık Mod',
      lightMode: 'Aydınlık Mod',
      errorOccurred: 'Bir hata oluştu',
      confirm: 'Onayla',
      context: 'Tablo',
      key: 'Kolon',
      originalShort: 'Orij.',
      originalValue: 'Orijinal Değer',
      locale: 'Dil',
      value: 'Değer',
      status: 'Durum',
      auto: 'Otomatik',
      manual: 'Manuel',
      manageLocales: 'Dilleri Yönet',
      updateUntranslatedFields: 'Yeni Alanları Güncelle',
      autoTranslate: 'Otomatik Çevir',
      sourceAndTargetMustDiffer: 'Kaynak ve hedef dil farklı olmalı.',
      autoTranslateSuccessCount: '{count} öğe otomatik çevrildi.',
      syncEntriesResult: 'Senkronize edildi: {count} yeni çeviri kaydı.',
      translated: 'Çevrildi',
      missing: 'Eksik',
      autoTranslateScope: 'Otomatik Çeviri Kapsamı',
      updateUntranslatedFieldsHint: '"Yeni Alanları Güncelle" butonu ile bu tablolardaki orijinal içerikler havuza çekilir.',
      processing: 'İşleniyor...',
      enterTargetLanguage: 'Hedef dil seçin. Aşağıdaki kaynak dilden seçilen dile çeviri yapılacaktır.',
      sourceLanguage: 'Orijinal dil',
      selectLanguagesFirst: 'Önce Dilleri Yönet\'ten dil seçin',
      sourceLanguageLabel: 'Kaynak dil (arayüz diliniz)',
      targetLanguage: 'Hedef dil',
      activeLocalesDescription: 'Sistem genelinde aktif dilleri seçin. Sadece ayar olarak kaydedilir; çeviri tablosuna ekleme yapılmaz.',
      selectSourceLanguageForSync: 'İçerideki veriler hangi dilde? Orijinal kayıt bu dilde işaretlenecek.',
      languageNames: {
        en: 'İngilizce',
        tr: 'Türkçe',
        de: 'Almanca',
        fr: 'Fransızca',
        es: 'İspanyolca',
        ar: 'Arapça',
        it: 'İtalyanca',
        ja: 'Japonca',
        zh: 'Çince',
        ru: 'Rusça',
      },
      warning: 'Uyarı',
    },
    login: {
        ...coreMessages.login,
        loginFailed: 'Giriş başarısız',
        emailRequired: 'E-posta gerekli',
        passwordRequired: 'Şifre gerekli',
        backendUnavailable: 'Kimlik doğrulama servisi kullanılamıyor.',
        backendConnectFailed: 'Kimlik doğrulama servisine bağlanılamadı.',
        backendConnectFailedDev:
            'API’ye ulaşılamıyor (geliştirme). Sunucu ve VITE_API_BASE_URL’i kontrol edin.',
        emailLabel: 'E-posta',
        emailPlaceholderFull: 'E-posta adresinizi giriniz',
        passwordLabel: 'Şifre',
        passwordPlaceholderFull: 'Şifreniz',
        hidePassword: 'Şifreyi gizle',
        showPassword: 'Şifreyi göster',
        loggingIn: 'Giriş yapılıyor…',
        submitButton: 'Giriş yap',
        errors: {
            ...coreMessages.login.errors,
            invalidCredentials: 'E-posta veya şifre hatalı.',
            sessionTooLarge: 'Oturum verisi çok büyük. Tekrar deneyin veya site verilerini temizleyin.',
            databaseUnavailable: 'Veritabanı kullanılamıyor.',
            accountInactive: 'Hesap pasif.',
            sessionExpired: 'Oturum süresi doldu.',
            tooManyAttempts: 'Çok fazla deneme. Daha sonra tekrar deneyin.',
        },
        featureTitle: "Operasyon ve finans kayıtlarınızı birleştirin",
        featureDescription: "QubePro ERP ile stok, satınalma, satış ve finans kayıtlarını takip edin.",
        featureCard1Title: "Ürün ve stok",
        featureCard1Description: "Ürünleri, depoları ve stok hareketlerini yönetin.",
        featureCard2Title: "Satınalma",
        featureCard2Description: "Satınalma belgelerini ve siparişleri takip edin.",
        featureCard3Title: "Satış belgeleri",
        featureCard3Description: "Satış siparişlerini ve faturaları yönetin.",
        featureCard4Title: "Finans hareketleri",
        featureCard4Description: "Banka, kasa ve finans kayıtlarını inceleyin.",
        darkMode: 'Karanlık tema',
        lightMode: 'Açık tema',
        pleaseWait: 'Lütfen bekleyin',
        serverConfiguring: 'Sunucu yapılandırılıyor…',
        dbCreating: 'Çalışma alanınız hazırlanıyor…',
        loginPageTitle: 'Giriş',
        languageToggleLabel: 'Dil',
    },
    sidebar: {
        ...coreMessages.sidebar,
        dashboard: 'Panel',
        settings: 'Ayarlar',
        toggleMenu: 'Menüyü aç',
        toggleMenuClose: 'Menüyü kapat',
        companies: 'Firmalar',
        logout: 'Çıkış yap',
        activityLogs: 'Aktivite günlükleri',
    },
  customFields: {
    title: 'Ek Alanlar',
    newField: 'Yeni Ek Alan',
    editField: 'Ek Alanı Düzenle',
    entityType: 'Kayıt Türü',
    code: 'Alan Kodu',
    label: 'Görünen Ad',
    codePlaceholder: 'Örn: ozelKod1',
    labelPlaceholder: 'Örn: Özel Kod 1',
    dataType: 'Veri Tipi',
    type: 'Tip',
    scope: 'Kapsam',
    companyId: 'Firma ID',
    companySelection: 'Firmalar',
    companySelectionPlaceholder: 'Boşsa genel, istersen firma seç',
    selectedCompanies: '{{count}} firma seçili',
    selectAllCompanies: 'Tüm firmaları seç',
    sortOrder: 'Sıra',
    required: 'Zorunlu',
    searchable: 'Aranabilir',
    showInForm: 'Formda göster',
    showInList: 'Kolon göster',
    formTab: 'Form Sekmesi',
    formTabSelect: 'Form Sekmesi',
    formTabPlaceholder: 'Boşsa Ek Alanlar sekmesine eklenir',
    defaultCustomTab: 'Ek Alanlar',
    selectEntityTypeFirst: 'Önce kayıt türü seçin',
    newFormTab: 'Yeni sekme',
    tabCode: 'Sekme Kodu',
    tabName: 'Sekme Adı',
    tabCodePlaceholder: 'Örn: operasyon',
    tabNamePlaceholder: 'Örn: Operasyon Bilgileri',
    fieldWidth: 'Satır Düzeni',
    widthFull: 'Satırda 1 alan',
    widthHalf: 'Satırda 2 alan',
    widthThird: 'Satırda 3 alan',
    widthQuarter: 'Satırda 4 alan',
    systemField: 'Sistem Alanı',
    description: 'Açıklama',
    options: 'Seçenekler',
    optionsPlaceholder: 'Her satır: kod:Etiket\nÖrn: draft:Taslak\nveya sadece Taslak',
    defaultValue: 'Varsayılan Değer',
    statusDistributionTitle: '{{title}} Durum Dağılımı',
    emptyMessage: 'Henüz ek alan tanımlanmamış.',
    globalScope: 'Genel',
    companyScope: 'Firma {{id}}',
    deleteSelected: 'Seçili sil',
    deleteSelectedMessage: '{{count}} ek alan silinecek. Bu işlem geri alınamaz.',
    formDesigner: 'Form Tasarımı',
    formDesignerTitle: 'Ek Alan Form Tasarımı',
    formDesignerEntityType: 'Tasarım yapılacak kayıt türü',
    formDesignerAllTabs: 'Tümü',
    formDesignerEmpty: 'Bu kayıt türünde ek alan yok.',
    formDesignerOriginalNotice: 'Orijinal form alanları korunur; bu ekran ek alanların sekme, sıra ve satır düzenini yönetir.',
    formDesignerSave: 'Tasarımı Kaydet',
    formDesignerSaved: 'Form tasarımı kaydedildi.',
    formDesignerMoveUp: 'Yukarı taşı',
    formDesignerMoveDown: 'Aşağı taşı',
    formDesignerFieldSettings: 'Alan düzeni',
    formDesignerQuickSave: 'Kaydet',
    formDesignerEditTab: 'Sekme düzenle',
    formDesignerDeleteTab: 'Sekmeyi sil',
    formDesignerTabEditorTitle: 'Sekme düzeni',
    formDesignerCloseTabEditor: 'Sekme düzenlemeyi kapat',
    dataTypes: {
      text: 'Metin',
      number: 'Sayı',
      date: 'Tarih',
      datetime: 'Tarih/Saat',
      boolean: 'Evet/Hayır',
      select: 'Seçim',
      json: 'JSON',
    },
  },
    activityLogs: {
        title: 'Aktivite günlükleri',
        searchPlaceholder: 'Ara (varlık adı, modül, eylem)…',
        allModules: 'Tüm modüller',
        allActions: 'Tüm eylemler',
        allSeverity: 'Tüm önem seviyeleri',
        allApps: 'Tüm uygulamalar',
        startDate: 'Başlangıç',
        endDate: 'Bitiş',
        exportCsv: "CSV'ye aktar",
        total: 'Toplam',
        today: 'Bugün',
        critical: 'Kritik',
        warning: 'Uyarı',
        severityInfo: 'Bilgi',
        exportFilenameStem: 'aktivite-gunlukleri',
        noLogs: 'Aktivite kaydı bulunamadı.',       system: 'Sistem',
        field: 'Alan',
        oldValue: 'Eski değer',
        newValue: 'Yeni değer',
        ip: 'IP',
        meta: 'İstek metadata',
        userAgent: 'User-Agent',
        entity: 'Varlık',
        severityCol: 'Önem',
        userCol: 'Kullanıcı',
        actionCol: 'Eylem',
        moduleCol: 'Modül',
        dateCol: 'Tarih',
        appCol: 'Uygulama',
        overviewTitle: 'Özet',
        severityChart: 'Önem dağılımı',
        topModulesChart: 'Hacme göre üst modüller',
        csvId: 'Kimlik',
        csvDate: 'Tarih',
        csvUser: 'Kullanıcı',
        csvAction: 'Eylem',
        csvModule: 'Modül',
        csvEntity: 'Varlık',
        csvSeverity: 'Önem',
        csvIp: 'IP',
        csvApplication: 'Uygulama',
      companyCol: 'Firma ID',
      allOutcomes: 'Tüm Sonuçlar',
      noLogsDesc: 'Kullanıcılar işlem yaptıkça kayıtlar burada görünür.',
      entityType: 'Kayıt türü',
      actorType: 'Aktör türü',
      outcome: 'Sonuç',
      successful: 'Başarılı',
      failed: 'Başarısız',
      denied: 'Reddedildi',
      reason: 'Gerekçe',
      requestId: 'İstek ID',
      correlationId: 'Korelasyon ID',
      integrity: 'Bütünlük kanıtı',
      outboxWarning: 'Audit teslim kuyruğu müdahale gerektiriyor.',
    },

  // Header Notifications page
  headerNotifications: {
    tabNotifications: 'Bildirimler',
    tabPreferences: 'Tercihler',
    markAllRead: 'Tümünü okundu yap',
    notifCount: '{total} bildirim',
    unreadCount: '{count} okunmamış',
    loading: 'Bildirimler yükleniyor...',
    noNotifications: 'Bildirim yok',    markRead: 'Okundu işaretle',    delete: 'Sil',   noPreferences: 'Tercih yok',
    noPreferencesDesc: 'Henüz bildirim kategorisi bulunmuyor. Bildirim alındığında tercihler otomatik oluşturulur.',
    preferencesHeader: 'Uygulama İçi Bildirim Tercihleri',
    prefItemDesc: 'Bu kategorideki bildirimleri uygulama içinde alın',
    readDistribution: 'Okuma durumu dağılımı',
    readStatusLabel: 'Okuma durumu',
    filterAll: 'Tümü',
    filterUnread: 'Okunmamış',
    filterRead: 'Okunmuş',
    colType: 'Tür',
    colTitle: 'Başlık',
    colMessage: 'İleti',
    colDate: 'Tarih',
    colRead: 'Durum',
    statusUnread: 'Okunmadı',
    statusRead: 'Okundu',
    searchNotifications: 'Başlık veya ileti ara…',
  },
};
